<template>
  <v-row v-if="linkData"
    ><v-col cols="12" >
      <v-data-table
        :headers="headers"
        :items="linkData.links"
        sort-by="linkText"
        class="elevation-1"
        hide-default-footer
        disable-pagination
        calculate-widths
        must-sort
        mobile-breakpoint="0"
        dense
        :search="search"
      >

        <template v-slot:top>
          <v-toolbar flat>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                  New Item
                </v-btn>
              </template>
              <v-row>
                <v-spacer />
                <v-col cols="11">
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="editedItem.linkText"
                              label="Link Text"
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="editedItem.link"
                              label="Link URL"
                              outlined
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="editedItem.linkDescription"
                              label="Link Description"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="close">
                                Cancel
                              </v-btn>
                              <v-btn color="blue darken-1" text @click="save">
                                Save
                              </v-btn>
                            </v-card-actions>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-spacer />
              </v-row>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 no-word-wrap"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
      
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
      
        <template v-slot:no-data>
          <v-btn color="primary" @click="getLinkData()"> Reset </v-btn>
        </template>
      
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  props: ["listid"],
  data: () => ({
    LINK_URLS: {
      DELETE: "/deleteLink",
      ADD: "/addLink",
      UPDATE: "/updateLink",
    },
    linkData: null,
    dialog: false,
    search: "",
    dialogDelete: false,
    headers: [
      { text: "Actions", value: "actions", sortable: false },
      {
        text: "Link Text",
        align: "start",
        value: "linkText",
      },
      {
        text: "Link URL",
        align: "start",
        value: "link",
        width: "25%",
      },
      {
        text: "Link Description",
        align: "start",
        value: "linkDescription",
      },

    ],
    editedIndex: -1,
    editedItem: {
      linkId: null,
      linkTypeId: null,
      linkText: "",
      link: "",
      linkDescription: "",
      countryId: null,
    },
    defaultItem: {
      linkId: null,
      linkTypeId: null,
      linkText: "",
      link: "",
      linkDescription: "",
      countryId: null,
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    async getLinkData() {
      if (!this.listid) {
        return;
      }
      const listRequest = serverFunctions.getDataRequestObject(null, this.listid);
      this.linkData = await serverFunctions.getRawPostResponse("/getLinks", listRequest);
    },
    editItem(item) {
      this.editedIndex = this.linkData.links.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.linkData.links.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.processLinkRequest(this.editedItem, this.LINK_URLS.DELETE);
      this.closeDelete();
    },
    async processLinkRequest(linkItem, actionUrl) {
      this.editedItem.linkTypeId = this.listid;
      const deleteLinkRequest = serverFunctions.getLinkRequestObject(
        userFunctions.getLoggedInUser(),
        linkItem
      );
      await serverFunctions.getPostResponse(actionUrl, deleteLinkRequest);
      this.getLinkData();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.editedItem.linkTypeId = this.listid;
      if (this.editedIndex > -1) {
        await this.processLinkRequest(this.editedItem, this.LINK_URLS.UPDATE);
      } else {
        await this.processLinkRequest(this.editedItem, this.LINK_URLS.ADD);
      }
      this.close();
    },
  },
  beforeMount() {
    this.getLinkData();
  },
};
</script>

<style scoped>
.no-word-wrap {
    word-break: break-word;
}
</style>
